// extracted by mini-css-extract-plugin
module.exports =  {"template-16":"Template16-b3VF__template-16","button":"Template16-xFNN__button","sentence":"Template16-WO20__sentence","options":"Template16-p1hE__options"};